import DapDSContentSwitcher from './content-switcher.component'

export * from './content-switcher.component'
export default DapDSContentSwitcher

DapDSContentSwitcher.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-content-switcher': DapDSContentSwitcher
  }
}
